import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { FadeUp } from "@/components/Motion";
import { ProductCard } from "@/pages/Home";
import { Seo } from "@/components/Seo";

export default function Shop() {
  const { t } = useI18n();
  const [products, setProducts] = useState([]);

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);

  return (
    <div className="pt-32 pb-32 min-h-screen" data-testid="shop-page">
      <Seo title={`${t.shop.t} — Madubau Dolomiti`} description={t.seo.shop_d} path="/shop" />
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <FadeUp className="mb-20">
          <h1 className="font-editorial italic font-light text-6xl lg:text-8xl text-cream leading-none">
            {t.shop.t}
          </h1>
        </FadeUp>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {products.map((p, i) => (
            <FadeUp key={p.id} delay={i * 0.06}>
              <ProductCard product={p} />
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
}
